export default "__VITE_ASSET__B3fW02Bf__"